import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    DynamicNumberButton,
    DynamicNumberLink
} from '@zoopla/dynamic-phone-number';

export const DynamicNumberWrapper = styled('div')(
    ({ theme: { spacing, iconSizes, mq } }) => css`
        display: none;
        height: ${iconSizes[2]};

        ${mq.medium} {
            display: inline-block;
        }

        ${DynamicNumberButton}, ${DynamicNumberLink} {
            padding: 0px;
            margin-right: ${spacing['24px']};
        }
    `
);

export const Loader = styled('img')(css`
    display: block;
    height: 2.5rem;
    margin: -1em 0;
    width: 2.5rem;
`);
